<script setup>
  import { toRef, computed, watchEffect, useTemplateRef } from 'vue'
  import UpgradeButton from '@/components/UpgradeButton.vue';
  import Icon from '@/components/icons/Icon.vue';
  import { useContainerViewTracking } from '@/composables/useContainerViewTracking';

  const props = defineProps({
    upgrade: {
      type: Array,
      required: true
    },
    productText: {
      type: [String, Object],
      required: true
    },
    buttonPosition: {
      type: String,
      default: 'inline'
    },
    clickLocation: {
      type: String,
      default: ''
    },
    trackingContainer: {
      type: String,
      required: false
    }
  })

  const upgradeBlockElement = useTemplateRef('upgradeBlockElement');

  const productText = toRef(props.productText);

  const messageText = computed(() => {
    if (!props.upgrade || !props.upgrade[1] || props.upgrade[1].length === 0) return `Upgrade to unlock ${productText.value}`;
    
    return `Upgrade to <strong>${formatMembershipLevels(props.upgrade[1])}</strong> to unlock ${productText.value}`
  });

  const buttonText = computed(() => {
    if (props.upgrade[2] === null) return 'Upgrade Now';

    return props.upgrade[2] ? 'Start Free Trial' : 'Upgrade Now';
  });

  // Only the Complete Report opts into container view tracking
  if (props.trackingContainer) {
    useContainerViewTracking(upgradeBlockElement, () => ({ Container: props.trackingContainer }));
  }

  // TODO: move to composable?
  function formatMembershipLevels(levels) {
    return levels.map((level, i) => {
      const capitalizedLevel = `${level[0].toUpperCase()}${level.slice(1)}`;

      if (i === 0) return capitalizedLevel;

      if (levels.length > 2) {
        return i < levels.length - 1 
          ? `, ${capitalizedLevel}` 
          : `, or ${capitalizedLevel}`
      };

      return ` or ${capitalizedLevel}`
    }).join('');
  }

</script>

<template>
  <div ref="upgradeBlockElement" class="jwx-upgrade-block-container">
    <div class="jwx-upgrade-block jwx-button-shadow" :data-button-position="props.buttonPosition">
      <div class="jwx-upgrade-block__content">
        <slot></slot>
        <p v-if="props.productText" v-html="messageText" class="jwx-upgrade-block__text"></p>
      </div>
      <Icon name="lock-unlocked" class="jwx-upgrade-block__icon" />
      <UpgradeButton :buttonText="buttonText" :clickLocation="props.clickLocation" />
    </div>   
  </div>
</template>